<div class="skeleton-wrapper" [style.gap]="gap()">
  @for (line of lineArray(); track $index) {
    <div
      class="skeleton-block"
      [ngStyle]="{
        width: width(),
        height: height(),
        'border-radius': borderRadius()
      }"
    ></div>
  }
</div>
